// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mcjn","name":"styles_name__3doSr","phone":"styles_phone__2_Ntu"};